export default __webpack_public_path__ + "chevron-right.e12b6cec.svg";